import {Settings} from '../Settings';
import {$body} from '../Constants';
import HtmlElement from './HtmlElement';
import Header from '../Elements/Header';

/**
 * Javascript Wrapper for the Banner HTMLElement
 */
class Banner extends HtmlElement {
  onReady() {
    this.adjustHeight();
    this.$nivoSlider = this.$element.find('.nivoSlider');
    this.$nivoControlNav = this.$element.find('.nivo-controlNav');

    if (this.$nivoControlNav.length == 1) {
      this.positionNivoControlNav();
    }
  }

  onResize() {
    this.adjustHeight();
  }

  adjustHeight() {
    if (Settings.bannerAdjust) {
      this.$element.css('margin-top', Header.getHeight());
    }
  }

  positionNivoControlNav() {
    this.$nivoControlNav.css('top', this.$nivoSlider.height());
  }
}

export default (new Banner($body.find('.banner')));
